
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.798.093L.778 4.843c-.742.185-.897 1.113-.327 1.574L3.817 9.13l12.61-6.084c.243-.119.45.232.23.388L5.317 11.449l-.756 2.89c-.222.846.705 1.478 1.364 1.01l2.988-2.11 3.947 3.176a.869.869 0 001.346-.308l6.625-14.752c.311-.69-.324-1.44-1.034-1.262z","fill":"#C4C4C4"}})])
          )
        }
      }
    